import {
  getObjectFromLocalStorage,
  saveObjectToLocalStorage,
} from './storageService';

function buildFilterKey(pageKey: string): string {
  return `${pageKey}|filter`;
}

function getLastFilterByKey(pageKey: string, TypeFilter: any) {
  const key = buildFilterKey(pageKey);
  const val = getObjectFromLocalStorage(key);
  return (val && new TypeFilter(val)) || new TypeFilter();
}

function upsertFilterToKey(pageKey: string, filter: any) {
  const tempFilter = { ...filter };
  delete tempFilter.skip;
  const key = buildFilterKey(pageKey);
  saveObjectToLocalStorage(key, tempFilter);
}

export { getLastFilterByKey, upsertFilterToKey };
